import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=9271deb6&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
import style0 from "./Form.vue?vue&type=style&index=0&id=9271deb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9271deb6",
  null
  
)

export default component.exports